import debounce from "lodash.debounce";
import { apiQueryClient } from '../../../App';
import { impersonationStaff } from '../../../services/api-query/auth'
import { saveAnalytics } from '../../../services/api-query/analytics'
import { getCurrentSession } from '../../../services/api-query/auth'
import { 
    app,
    analyticsDomain,
    analyticsPage,
    analyticsCta,
  } from '../../../services/constants'


export const getPageName = (id: string, group = 'hourly') => {
    let name = analyticsPage.trendsHourlyHome
    switch(id+group) {
      case 'homehourly':
        name = analyticsPage.trendsHourlyHome;
        break;
      case 'homedaily':
        name = analyticsPage.trendsDailyHome;
        break;
      case 'homemonthly':
        name = analyticsPage.trendsMonthlyHome;
        break;
      case 'solarhourly':
        name = analyticsPage.trendsHourlySolar;
        break;
      case 'solardaily':
        name = analyticsPage.trendsDailySolar;
        break;
      case 'solarmonthly':
        name = analyticsPage.trendsMonthlySolar;
        break;
      case 'gridhourly':
        name = analyticsPage.trendsHourlyGrid;
        break;
      case 'griddaily':
        name = analyticsPage.trendsDailyGrid;
        break;
      case 'gridmonthly':
        name = analyticsPage.trendsMonthlyGrid;
        break;
      case 'batteryhourly':
        name = analyticsPage.trendsHourlyBattery;
        break;
      case 'batterydaily':
        name = analyticsPage.trendsDailyBattery;
        break;
      case 'batterymonthly':
        name = analyticsPage.trendsMonthlyBattery;
        break;
      default: 
        break;
    }
  
    return name
  }

export const clickAnalyticsEF = (selected: string, metadata={}) => {
    let name = selected
    switch(selected) {
      case "home":
        name = analyticsCta.energyFlowHome
        break;
      case "solar":
        name = analyticsCta.energyFlowSolar
        break;
      case "grid":
        name = analyticsCta.energyFlowGrid
        break;
      case "battery":
        name = analyticsCta.energyFlowBattery
        break;
      default:
        break;
    }
    sendClickAnalytics('/dashboard',
            {
                domain: analyticsDomain.dashboard,
                name,
                metadata,
            })
  }
  
export const clickAnalyticsTiles = (selected: string, metadata={}, tou=false) => {
    let name = selected
    switch(selected) {
        case "home":
            name = analyticsCta.tileTotalHomeUsage
            break;
        case "solar":
            name = analyticsCta.tileSolarGeneration
            break;
        case "grid":
            if(tou){
                name = analyticsCta.tileNetGridTimeOfUseImport
            } else {
                name = analyticsCta.tileNetGridImport
            }
            break;
        case "homeUsage":
            name = analyticsCta.tileSystemPerformance
            break;
        case "solarProduction":
            name = analyticsCta.tileSolarUtilization
            break;
        case "hotwater":
            name = analyticsCta.tileHotWater
            break;
        default:
            break;
    }
    sendClickAnalytics('/dashboard', {
        domain: analyticsDomain.dashboard,
        name,
        metadata,
    })
  }

export const clickAnalyticsProfile = (selected: string, metadata={}) => {
  let name = selected
  switch(selected) {
      case "details":
          name = analyticsCta.customerProfile
          break;
      case "system":
          name = analyticsCta.systemProfile
          break;
      case "help":
          name = analyticsCta.helpAndSupport
          break;
      case "signout":
        name = analyticsCta.signOut
        break;
      default:
          break;
  }
 sendClickAnalytics('/profile', {
      domain: analyticsDomain.profile,
      name,
      metadata,
    })
}

export const clickAnalyticsHW = (selected: string, metadata={}) => {
  let name = selected
  switch(selected) {
      case "Enabled":
          name = analyticsCta.enableHotWaterEnergySaving
          break;
      case "Paused":
          name = analyticsCta.pauseHotWaterEnergySaving
          break;
      case "Disabled":
          name = analyticsCta.disableHotWaterEnergySaving
          break;
      case "troubleshooting":
          name = analyticsCta.hotWaterTroubleshooting
          break;
      case "question":
          name = analyticsCta.hotWaterTroubleshootingQuestion
          break;
      default:
          break;
  }
  sendClickAnalytics('/rightPanel', {
      domain: analyticsDomain.hotWater,
      name,
      metadata,
    })
}

export const clickAnalyticsReport = (selected: string, metadata={}) => {
  let name = selected
  switch(selected) {
      case "home":
          name = analyticsCta.trendsHome
          break;
      case "solar":
          name = analyticsCta.trendsSolar
          break;
      case "grid":
          name = analyticsCta.trendsGrid
          break;
      case "battery":
          name = analyticsCta.trendsBattery
          break;
      default:
          break;
  }
  sendClickAnalytics('/performance', {
      domain: analyticsDomain.trends,
      name,
      metadata,
  })
}

const sendAnalytics = async (data: any)=>{
    try {
      const staffInfo = impersonationStaff();
      if(staffInfo) {
        const staff = staffInfo?.split('::')[1] || staffInfo?.split('::')[0]
        if(data?.value) {
          if(data?.value?.metadata) {
            data.value.metadata.impersonatedBy = staff
          } else {
            data.value.metadata = {
              impersonatedBy: staff
            }
          }
        }
      }
      const currentSession: any = apiQueryClient?.getQueryData(['CurrentSession'])
      saveAnalytics(data, currentSession);
    } catch {
      console.log('Error in saving analytics')
    }
}
const sessionAnalytics = async (path: string, value: string) => {
  sendAnalytics({
      app,
      type: 'session',
      path,
      value: {
        type: value
      },
      isTesting: (process.env.REACT_APP_ENV!=='production')?1:0
  })
}
const viewAnalytics = async (path: string, value: any) => {
  sendAnalytics({
      app,
      type: 'view',
      path,
      value,
      isTesting: (process.env.REACT_APP_ENV!=='production')?1:0
  })
}
const clickAnalytics =  async (path: string, value: any) => {
  sendAnalytics({
      app,
      type: 'action',
      path,
      value,
      isTesting: (process.env.REACT_APP_ENV!=='production')?1:0
  })
}
export const sendSessionAnalytics = debounce(sessionAnalytics, 500, { trailing: true });
export const sendViewAnalytics = debounce(viewAnalytics, 500, { trailing: true });
export const sendClickAnalytics =  debounce(clickAnalytics, 1000, { trailing: true });